import React, { useState, useEffect } from "react";
import Date from "../../super_dashboard/components/Date";

import { useNavigate } from "react-router";
import SelectLabels from "../../components/SelectLabels";
import { managerAxios } from "../../axiosInstance";
// import { createData, fetchData } from "../../managerApi";
import { createData, fetchData } from "../../utility/managerApi";
import { getDataById } from "../../utility/managerApi";
import UploadImage from "../../components/UploadImage";

function AddProductForm() {
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [productData, setProductData] = useState({});
  const [categoryData, setCategoryData] = useState([]);

  const [subsingleData, setSubsingleData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [formData, setFormData] = useState({
    store: "",
    warehouse: "",
    supplier: "",
    cat_id: 11,
    sub_cat_id: 3,
    product_name: "",
    password: "",
    sku: "",
    barcode: "",
    quantity: "",
    price: "",
    manufacturing_date: "",
    expiring_date: "",
    product_image: file,
    description: "",
  });

  const navigate = useNavigate();
  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    setFormData((prevData) => ({
      ...prevData,
      cat_id: value, // Update the corresponding field in state
    }));
    // console.log("Selected Category ID:", value); // You can use this value as needed
  };

  const handleSubcategoryChange = (value) => {
    setSelectedSubcategory(value);
    setFormData((prevData) => ({
      ...prevData,
      sub_cat_id: value, // Update the corresponding field in state
    }));
  };

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("categories/show/", id);

    setSubsingleData(response?.data?.data?.sub_categories);
  };

  const fetchProductData = async (page) => {
    try {
      const response = await managerAxios.get("categories");
      const data = response?.data?.data;
      // console.log(data);
      setCategoryData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedCategory != null) {
      handleSingleFile(selectedCategory);
    }
  }, [selectedCategory]);

  useEffect(() => {
    fetchProductData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  // const handleFileChange = (e) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     product_image: e.target.files[0], // Correct the key here
  //   }));
  // };

  const handleDateChange = (year, month, day, type) => {
    setFormData((prevData) => ({
      ...prevData,
      [type]: `${year}-${month}-${day}`,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();

    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const response = await createData("products/store", data);
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      setTimeout(() => {
        navigate("/manager/products");
      }, 2000);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="   ">
      <div className="flex">
        {/* Photo of company code here */}
        <UploadImage
          imageUrl={imageUrl}
          setImageUrl={setImageUrl}
          onImageUpload={(url) =>
            setFormData((prevData) => ({
              ...prevData,
              product_image: url,
            }))
          }
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-x-4 gap-y-4  flex-wrap ">
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Store</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Store"
            type="text "
            name="store"
            // id="email"
            value={formData.store}
            onChange={handleChange}
            // required
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Warehouse</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Warehouse"
            type="text "
            name="warehouse"
            // id="email"
            value={formData.warehouse}
            onChange={handleChange}
            // required
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Supplier</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Supplier"
            type="text "
            name="supplier"
            // id="email"
            value={formData.supplier}
            onChange={handleChange}
            // required
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="Manufacturing Date">
            Category <span className="text-red-500">*</span>
          </label>
          {/* Na here the select */}
          <SelectLabels
            categoryData={categoryData}
            text="Select a Category"
            valueKey="id"
            labelKey="cat_name"
            onSelectChange={handleCategoryChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="Manufacturing Date">
            Subcategory <span className="text-red-500">*</span>
          </label>
          <SelectLabels
            categoryData={subsingleData}
            text="Select Sub-category"
            valueKey="id"
            labelKey="sub_cat_name"
            onSelectChange={handleSubcategoryChange}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">
            Product Name <span className="text-red-500">*</span>
          </label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Product Name"
            type="text "
            name="product_name"
            // id="email"
            value={formData.product_name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">SKU</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="SKU"
            type="text "
            name="sku"
            // id="email"
            value={formData.sku}
            onChange={handleChange}
            // required
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">Barcode</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Barcode"
            type="text "
            name="barcode"
            // id="email"
            value={formData.barcode}
            onChange={handleChange}
            // required
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="store">
            Quantity <span className="text-red-500">*</span>
          </label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Quantity"
            type="number "
            name="quantity"
            // id="email"
            value={formData.quantity}
            onChange={handleChange}
            required
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/ lg:max-w-[32%]">
          <label htmlFor="store">
            Price <span className="text-red-500">*</span>
          </label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none "
            placeholder="Price"
            type="number"
            name="price"
            // id="email"
            value={formData.price}
            onChange={handleChange}
            required
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="Manufacturing Date">Manufacturing Date</label>
          <Date
            onDateChange={handleDateChange}
            type={"manufacturing_date"}
            className={"lg:w-full"}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/3 lg:max-w-[32%]">
          <label htmlFor="Expiring Date">Expiring Date</label>
          <Date
            onDateChange={handleDateChange}
            type={"expiring_date"}
            className={"lg:w-full"}
          />
        </div>
        <div className="w-[99%] flex flex-col ">
          <label htmlFor="">Product Description</label>
          <textarea
            name="description"
            id="product_description"
            className="border-2 p-2"
            placeholder="Product description"
            onChange={handleChange}
            value={formData.description}
          ></textarea>
        </div>
      </div>

      <div className="flex justify-center my-6 text-white font-medium text-xl p-3 bg-darkblue rounded-lg">
        <button type="submit" className="w-full h-full" disabled={loading}>
          {loading ? "Saving..." : "Save Product"}
        </button>
      </div>
    </form>
  );
}

export default AddProductForm;
